
import { useTranslatedText } from "@/hooks/useTranslate";
import { Globe, Shield, Zap, Code, Database, Cloud, Cpu, Layers } from "lucide-react";

const TrustSection = () => {
  const titleText = useTranslatedText("Tecnologías que dominamos");

  const items = [
    { icon: <Code className="w-6 h-6" />, label: "React" },
    { icon: <Globe className="w-6 h-6" />, label: "Next.js" },
    { icon: <Database className="w-6 h-6" />, label: "PostgreSQL" },
    { icon: <Cloud className="w-6 h-6" />, label: "AWS" },
    { icon: <Zap className="w-6 h-6" />, label: "Node.js" },
    { icon: <Shield className="w-6 h-6" />, label: "TypeScript" },
    { icon: <Cpu className="w-6 h-6" />, label: "Python" },
    { icon: <Layers className="w-6 h-6" />, label: "Docker" },
  ];

  // Duplicate for seamless loop
  const allItems = [...items, ...items];

  return (
    <section className="py-12 bg-techno-dark border-y border-white/5 overflow-hidden relative">
      <div className="container mx-auto px-4 mb-6">
        <p className="text-center text-gray-400 text-sm uppercase tracking-widest">{titleText}</p>
      </div>
      <div className="marquee-track">
        {allItems.map((item, i) => (
          <div
            key={i}
            className="flex items-center gap-3 px-8 py-3 mx-4 glass rounded-full whitespace-nowrap text-gray-300 hover:text-techno-purple transition-colors duration-300"
          >
            {item.icon}
            <span className="font-medium">{item.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustSection;
